export const FORM_SIDEBAR_DROPPABLE_ID = 'form-sidebar';
export const FORM_EDITOR_DROPPABLE_ID = 'form-editor';
